import React, { createContext, useContext, useMemo, useRef } from "react";
import { Animated } from "react-native";

type ScrollHideContextValue = {
  progress: Animated.Value;
};

const ScrollHideContext = createContext<ScrollHideContextValue | null>(null);

export function ScrollHideProvider({ children }: { children: React.ReactNode }) {
  const progress = useRef(new Animated.Value(0)).current;
  const value = useMemo(() => ({ progress }), [progress]);
  return (
    <ScrollHideContext.Provider value={value}>
      {children}
    </ScrollHideContext.Provider>
  );
}

export function useScrollHideProgress(): Animated.Value {
  const ctx = useContext(ScrollHideContext);
  if (!ctx) {
    throw new Error(
      "useScrollHideProgress must be used inside ScrollHideProvider",
    );
  }
  return ctx.progress;
}
